import UserManager from "./UserManager";

const AuthManager = {
    name: "auth",
    setAuthSession: (auth) => {
        localStorage.setItem(AuthManager.name, JSON.stringify(auth));
    },
    getAuthSession: () => {
        const auth = localStorage.getItem(AuthManager.name);
        if (auth !== null) return JSON.parse(auth);
        return null;
    },
    getTokenAuthSession: () => {
        const auth = AuthManager.getAuthSession();
        if (auth !== null) return auth.accessToken;
        return null;
    },
    isTokenValid: () => {
        const auth = AuthManager.getAuthSession();
        if (auth !== null) {
            const today = new Date();
            if (today < new Date(auth.dateExpireToken)) return true;
        }
        AuthManager.removeAuth();
        return false;
    },
    calcDateExpireToken: (dateCreated, expired) =>
        new Date(dateCreated + expired * 1000),
    removeAuth: () => {
        localStorage.removeItem(AuthManager.name);
    },
    removeAuthSession: () => {
        AuthManager.removeAuth();
        UserManager.removeUser();
    },
};

export default AuthManager;
